import { images } from "../constants";

export const historyData = {
    title: 'Historia',
    page: 'O nas',
    heading: 'Dzieje Dworu',
    subHeading: 'Poznaj historię Imielna',
    intro: 'Zespół dworsko-parkowy w Imielnie to jedno z najcenniejszych świadectw historii ziemi kutnowskiej — miejsce, w którym splatają się losy dawnych właścicieli, zmieniających się epok oraz lokalnej społeczności. Mimo że dziś obiekt wymaga pilnej opieki, jego historia i zachowany układ przestrzenny czynią go wyjątkowym zabytkiem o ogromnym znaczeniu kulturowym i przyrodniczym.',

    // Lista bloków historii
    blocks: [
        {
            id: 1,
            image: images.history1, // Placeholder: "https://via.placeholder.com/600x400?text=Wczesny+XIX+wiek"
            iconType: 'history', // Typ ikony do wyboru w komponencie
            title: 'Początki dworu – ślady wczesnego XIX wieku',
            paragraphs: [
                'Najstarsze wzmianki o dworze pochodzą z 1810 roku. W inwentarzu majątkowym opisano wówczas drewniany dom wzniesiony w konstrukcji szachulcowej, kryty dachówką, z kilkoma izbami, piecem kaflowym oraz niewielkim ogrodem przylegającym do sionki. To właśnie tam biją pierwsze znane źródłom „korzenie” imielneńskiego dworu – prostego, ale ważnego dla lokalnej społeczności.'
            ],
            reverse: false // Czy zdjęcie ma być po prawej stronie?
        },
        {
            id: 2,
            image: images.history2, // Placeholder: "https://via.placeholder.com/600x400?text=Murowany+Dwor+1850"
            iconType: 'landmark',
            title: 'Rozkwit majątku – nowy dwór i park z połowy XIX wieku',
            paragraphs: [
                'Najbardziej rozpoznawalna część dzisiejszego założenia powstała około 1850 roku, kiedy wybudowano murowany dwór otoczony parkiem. To dzieło właścicieli majątki, którzy z ambicją i rozmachem stworzyli reprezentacyjną siedzibę ziemiańską. Właśnie ta odsłona budynku oraz towarzyszące jej założenie parkowe zostały wpisane do rejestru zabytków ze względu na wyjątkowe walory historyczne i kompozycyjne.',
                'Park, z bogatym drzewostanem i malowniczym układem alei, zachował do dziś wiele elementów dawnego charakteru, stając się cennym fragmentem lokalnego krajobrazu.'
            ],
            reverse: true
        },
        {
            id: 3,
            image: images.history3, // Placeholder: "https://via.placeholder.com/600x400?text=XX+Wiek"
            iconType: 'history',
            title: 'Zmienne losy – XX wiek i powojenne przeobrażenia',
            paragraphs: [
                'Po II wojnie światowej dwór został znacjonalizowany. Przez wiele lat pełnił funkcję budynku mieszkalnego dla pracowników PGR-u, a później – w latach 90. – mieścił lokalny klub. Po likwidacji PGR-u obiekt opustoszał i zaczął popadać w coraz większą ruinę. Choć z czasem wrócił do spadkobierców dawnych właścicieli, jego stan techniczny nadal wymaga pilnych działań ratunkowych.'
            ],
            reverse: false
        }
    ],

    // Sekcja Dziedzictwo
    heritage: {
        title: 'Dziedzictwo warte ocalenia',
        intro: 'Zespół dworsko-parkowy w Imielnie to żywa opowieść o zmieniających się czasach, o ziemiańskich tradycjach i o powojennej transformacji. Jego wartość wynika z:',
        list: [
            'zachowanego historycznego układu przestrzennego,',
            'starodrzewu i unikatowych walorów przyrodniczych,',
            'znaczenia edukacyjnego i kulturowego,',
            'potencjału do rewitalizacji i stworzenia miejsca otwartego dla ludzi.'
        ]
    },

    // Sekcja Misja
    mission: {
        title: 'Nasza misja',
        text: 'Fundacja podejmuje działania na rzecz ochrony, dokumentowania i przywracania świetności zespołu dworsko-parkowego w Imielnie. Wierzymy, że to wyjątkowe miejsce może ponownie stać się przestrzenią kultury, edukacji oraz dialogu między przeszłością a współczesnością.',
        slogan: 'Chcemy ocalić nie tylko mury — chcemy ocalić pamięć.'
    }
};

export default historyData;